import * as types from './constants';

// Delete Lookbook
export const deleteLookbookRequest = data => (
  { type: types.DELETE_LOOKBOOK_REQUEST, payload: data }
);

export const deleteLookbookDone = data => (
  { type: types.DELETE_LOOKBOOK_DONE, payload: data }
);

export const deleteLookbookFailed = errors => (
  { type: types.DELETE_LOOKBOOK_FAILED, payload: errors }
);